import { render } from "./opinion.vue?vue&type=template&id=317c9567&scoped=true"
import script from "./opinion.vue?vue&type=script&lang=js"
export * from "./opinion.vue?vue&type=script&lang=js"

import "./opinion.vue?vue&type=style&index=0&id=317c9567&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317c9567"]])

export default __exports__